<template>
  <div class="product">
    <div style="width:100%;display: flex;justify-content: space-between;margin-bottom: 20px;">
      <div style="display: flex;gap:10px">
        <!-- 产品目录 -->
        <el-select v-model="selectedProductCategory" placeholder="请选择">
          <!-- 搜索 -->
          <el-option v-for="item in productCategories" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="getProducts()">搜索</el-button>
      </div>
      <el-button type="primary" @click="openDialog()">新增产品</el-button>

    </div>

    <el-table :data="products" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="序号" width="180"></el-table-column>
      <el-table-column prop="name" label="产品名称" width="180"></el-table-column>
      <el-table-column prop="image" label="图片" width="200">
        <template slot-scope="scope">
          <img style="width:100px" :src="imgserver + scope.row.image" alt />
        </template>
      </el-table-column>
      <el-table-column prop="image" label="参数图片" width="200">
        <template slot-scope="scope">
          <img style="width:100px" :src="imgserver + scope.row.parameterImg" alt />
        </template>
      </el-table-column>
      <!-- <el-table-column prop="description" label="产品描述"></el-table-column> -->
      <el-table-column label="产品描述">
        <template slot-scope="scope">
          <div v-html="scope.row.description" style="max-height: 100px;overflow: auto;"></div>
          </template>
        </el-table-column>
      <el-table-column prop="categoryId" label="产品类别">
        <template slot-scope="scope">{{ getCategoryName(scope.row.categoryId) }}</template>
      </el-table-column>
      <!-- 操作  -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="updateProductVisible(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="title" :visible.sync="dialogVisible">
      <el-form :model="newProduct">
        <el-form-item label="产品名称" :label-width="formLabelWidth">
          <el-input v-model="newProduct.name"></el-input>
        </el-form-item>
        <el-form-item label="产品图片" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :action="$imgUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img v-if="newProduct.image" :src="imgserver+newProduct.image" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="参数图片" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :action="$imgUrl"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccessParameterImg"
          >
            <img v-if="newProduct.parameterImg" :src="imgserver+newProduct.parameterImg" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="产品描述" :label-width="formLabelWidth">
          <el-input v-model="newProduct.description"></el-input>
        </el-form-item> -->
        <el-form-item label="产品描述" :label-width="formLabelWidth">
          <Editor v-model = "newProduct.description" />
          <!-- <el-input type="textarea" :rows="10" v-model="formData.description" autocomplete="off"></el-input> -->
        </el-form-item>
        <el-form-item label="产品类别" :label-width="formLabelWidth">
          <el-select v-model="newProduct.categoryId" placeholder="请选择">
            <el-option v-for="item in productCategories" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOk()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from './Editor.vue'
export default {
  components: {
    Editor
  },
  data() {
    return {
      headers:{},
      loading: false,
      dialogVisible: false,
      title: '新增产品',
      products: [],
      productCategories: [],
      selectedProductCategory: 0,
      formLabelWidth: "120px",
      newProduct: {
        name: '',
        image: '',
        parameterImg: '',
        description: '',
        categoryId: null
      }
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
      window.console.log(response, file, fileList);
      this.newProduct.image = response.result;
    },
    handleSuccessParameterImg(response, file, fileList) {
      window.console.log(response, file, fileList);
      this.newProduct.parameterImg = response.result;
    },
    async getProducts() {
      this.loading = true;
      this.$http.get(`/Product/ProductCategories/${this.selectedProductCategory}/Products`)
        .then(response => {
          this.products = response.result;
          this.loading = false;
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    },
    async getProductCategories() {
      this.$http.get('Product/ProductCategories')
        .then(response => {
          // 自开始加一个全部
          response.result.unshift({ id: 0, name: '全部' });
          this.productCategories = response.result;
        })
        .catch(error => {
          console.error(error);
        });
    },
    updateProductVisible(product) {
      this.newProduct = product;
      this.title = '编辑产品';
      this.dialogVisible = true;
    },
    updateProduct(product) {
      this.$http.put(`Product/Products/${product.id}`, product)
        .then(response => {
          if (response.errorCode===200) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "更新成功!"
            });
            this.getProducts();
          }
        })
        .catch(error => {
          console.error(error);
          // Handle error here, e.g. show an error message
        });
    },
    getCategoryName(categoryId) {
      const category = this.productCategories.find(c => c.id === categoryId);
      return category ? category.name : '';
    },
    openDialog() {
      this.dialogVisible = true;
      this.title = '新增产品';
    },
    async handleOk() {
      if(this.title==='编辑产品'){
        this.updateProduct(this.newProduct);
      }else{
        this.$http.post('Product/Products', this.newProduct)
        .then(response => {
          if (response.errorCode===200) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.getProducts();
          }
        })
    }
      },
  // 删除，需要有二次提示
  handleDelete(index, row) {
    this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        this.$http.delete(`Product/Products/${row.id}`)
          .then(response => {
            this.products.splice(index, 1);
            if(response.errorCode===200){
              this.$message({
              type: "success",
              message: "删除成功!"
            });
            }else{
              this.$message({
                message: response.result,
                type: 'error'
              });
            }
          })
          .catch(error => {
            if (error.response.data.result) {
              this.$message({
                message: error.response.data.result,
                type: 'error'
              });
            }
          });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
  }

  },

  created() {
    let token = "Bearer " + sessionStorage.getItem("token");
    this.headers = {
      Authorization: token
    };
    this.getProducts();
    this.getProductCategories();
  }
};
</script>

<style scoped>
.product {
  padding: 20px;
}
</style>